import { LOGIN_OR_JOIN_METHOD_QUERY_KEY } from './constants';

export function getLoginOrJoinMethodQueryKey(): string {
	return LOGIN_OR_JOIN_METHOD_QUERY_KEY;
}
